import React, { useState } from 'react';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.min.css';
import * as validator from '../../utils/validators/ResetUserPasswordValidator';
import { useTranslation } from 'react-i18next';
import useAxiosPrivate from '../../apis/useAxiosPrivate';
import { ValidationError } from 'yup';

const RESET_USERS_PASSWORD = "/users/admin/reset-password";

const ResetUserPassword = ({ currentUser, isEdit = false, setShowResetModal = null }) => {
    const { t, i18n } = useTranslation();
    const axiosPrivate = useAxiosPrivate();
    const [errors, setErrors] = useState({});
    const tResetUserPasswordInfo = t("resetPasswordForm");

    const handleResetUserPassword = async (e) => {
        e.preventDefault();
        const form = new FormData(e.target);
        const data = Object.fromEntries(form.entries());
        const formData = { ...data };
        try {
            await validator.validationSchema(tResetUserPasswordInfo, t("requiredMessage"))
                .validate(formData, { abortEarly: false });
            setErrors(null);

            const infoResponse = await axiosPrivate.post(
                RESET_USERS_PASSWORD, formData, {
                headers: { 'Accept-Language': i18n.language }
            });

            if (!isEdit) {
                e.target.querySelectorAll('input').forEach(input => {
                    input.value = '';
                });
            }
            toast.success(infoResponse?.data?.message);
            if (setShowResetModal) {
                setShowResetModal({ user: null, status: false })
            }
        } catch (error) {
            if (error instanceof ValidationError) {

                console.log(error instanceof ValidationError ? "validation error..." : error);
                let allErrors = {};
                error.inner.forEach((err) => {
                    allErrors[err.path] = err.message;
                });
                setErrors(allErrors);
            } else {
                if (!isEdit) {
                    e.target.querySelectorAll('input').forEach(input => { input.value = ""; });
                }
                toast.error(error.response?.data?.message || "An error occurred");
                console.error(error);
            }
        }
    };

    return (
        <div>
            <form className='w-full' onSubmit={handleResetUserPassword} method='post'>
                <div className="grid md:grid-cols-2 lg:grid-cols-3 grid-cols-1 gap-4">
                    <div className="w-full my-4 mx-2">
                        <label htmlFor="phone" className="text-lg">{tResetUserPasswordInfo.phone?.label}</label>
                        <input type="text" name="phone" id="phone" defaultValue={currentUser?.userPhone ?? ''} className="sm:text-sm bg-slate-100 rounded-lg w-full p-2.5" placeholder={tResetUserPasswordInfo.phone?.placeholder} />
                        {errors?.phone && <div className='text-red-600'>{errors.phone}</div>}
                    </div>
                    <div className="w-full my-4 mx-2">
                        <label htmlFor="password" className="text-lg">{tResetUserPasswordInfo.newPassword?.label}</label>
                        <input type="password" name="new_password" id="new_password" className="sm:text-sm bg-slate-100 rounded-lg w-full p-2.5" placeholder={tResetUserPasswordInfo.newPassword?.placeholder} />
                        {errors?.new_password && <div className='text-red-600'>{errors.new_password}</div>}
                    </div>
                    <div className="w-full my-4 mx-2">
                        <label htmlFor="password" className="text-lg">{tResetUserPasswordInfo.newPasswordConfirm?.label}</label>
                        <input type="password" name="new_password_confirmation" id="new_password_confirmation" className="sm:text-sm bg-slate-100 rounded-lg w-full p-2.5" placeholder={tResetUserPasswordInfo.newPasswordConfirm?.placeholder} />
                        {errors?.new_password_confirmation && <div className='text-red-600'>{errors.new_password_confirmation}</div>}
                    </div>
                </div>
                <button type="submit" className="bg-primary-color text-white w-full py-2 my-10">{tResetUserPasswordInfo.resetBtn}</button>
            </form>
        </div>
    );
};

export default ResetUserPassword;